export const ELEMENTS_LOAD = 'ELEMENTS_LOAD';
export const ELEMENTS_PURGE = 'ELEMENTS_PURGE';

// Client persistence - Elements will be saved to IndexedDB but not to redux memory
export const ELEMENTS_LOAD_INTO_WORKER_CACHE = 'ELEMENTS_LOAD_INTO_WORKER_CACHE';
export const ELEMENTS_RESET_SCORES = 'ELEMENTS_RESET_SCORES';
